import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';

interface CouponTypes {
  is_generic: boolean;
  is_unique: boolean;
}

interface Offer {
  _id: string;
  headline: string;
  sub_title: string;
  public_img_url?: string;
  video_url?: string;
  is_default: boolean;
  is_approved: boolean;
  total_count?: number;
  used_codes?: number;
  unused_codes?: number;
  cta?: {
    action_type?: string;
  };
  shopDetail?: {
    location?: boolean;
  };
  shop_id_list?: string[];
}

@Component({
    selector: 'app-litmus-intraction-offers',
    templateUrl: './litmus-intraction-offers.component.html',
    styleUrl: './litmus-intraction-offers.component.scss',
    imports: [FormsModule, NgIf, NgFor]
})
export class LitmusIntractionOffersComponent implements OnInit {
  // Filter values
  filterByStatusValue: string = '2';
  filterByOfferTypeValue: string = '0';
  searchText: string = '';

  // Offers data
  offers: Offer[] = [];
  
  // Flags
  isCouponCode: boolean = true;
  pagerBusy: boolean = false;
  noMoreData: boolean = false;
  
  // Coupon Types
  couponTypes: CouponTypes = {
    is_generic: true,
    is_unique: false
  };
  
  // Selected offer
  selectedOffer: Offer | null = null;
  
  // Notification message
  triggerOffersInfoMsg: string = '';

  constructor() { }

  ngOnInit(): void {
    // Load dummy data for demonstration
    this.loadOffers();
  }

  loadOffers(): void {
    // Simulate loading data from API
    setTimeout(() => {
      this.offers = [
        {
          _id: '1',
          headline: 'Summer Sale',
          sub_title: '50% Off on All Items',
          public_img_url: 'assets/offers/summer-sale.jpg',
          is_default: true,
          is_approved: true,
          total_count: 100,
          used_codes: 45,
          unused_codes: 55,
          cta: {
            action_type: 'get_code'
          },
          shopDetail: {
            location: true
          }
        },
        {
          _id: '2',
          headline: 'Weekend Special',
          sub_title: 'Buy 1 Get 1 Free',
          public_img_url: 'assets/offers/weekend-special.jpg',
          is_default: false,
          is_approved: true,
          total_count: 0,
          used_codes: 0,
          unused_codes: 0,
          cta: {
            action_type: 'redirect'
          }
        },
        {
          _id: '3',
          headline: 'New Year Discount',
          sub_title: 'Flat 30% Off',
          public_img_url: 'assets/offers/new-year.jpg',
          is_default: false,
          is_approved: false,
          total_count: 200,
          used_codes: 75,
          unused_codes: 125,
          cta: {
            action_type: 'get_code'
          }
        },
        {
          _id: '4',
          headline: 'Holiday Special',
          sub_title: 'Special Discounts',
          video_url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          is_default: false,
          is_approved: true,
          cta: {
            action_type: 'redirect'
          }
        }
      ];
    }, 500);
  }

  changeFilterOffer(value: string): void {
    this.filterByStatusValue = value;
    console.log('Filter changed to:', value);
    // Would typically load new data based on filter
  }

  changeFilterByOfferType(value: string): void {
    this.filterByOfferTypeValue = value;
    console.log('Offer type filter changed to:', value);
    // Would typically load new data based on filter
  }

  searchOffersByText(text: string): void {
    this.searchText = text;
    console.log('Searching for:', text);
    // Would typically search offers based on text
  }

  resetOffer(): void {
    this.filterByStatusValue = '2';
    this.filterByOfferTypeValue = '0';
    this.searchText = '';
    console.log('Filters reset');
    // Would typically reload default data
  }

  showOfferTemplateList(): void {
    console.log('Show offer template list');
    // Would typically open modal or navigate to create new offer
  }

  getSelectedOffer(offer: Offer): void {
    this.selectedOffer = offer;
    console.log('Selected offer:', offer);
  }

  removeOffer(offerId: string, index: number, event: Event): void {
    event.preventDefault();
    if (confirm('Are you sure you want to delete this offer?')) {
      console.log('Removing offer:', offerId);
      this.offers = this.offers.filter(offer => offer._id !== offerId);
    }
  }

  setDefaultCampaign(offerId: string, shopIdList: string[] | undefined, index: number): void {
    console.log('Setting offer as default:', offerId);
    this.offers.forEach(offer => {
      offer.is_default = offer._id === offerId;
    });
  }

  triggerOffersToNearbyUsers(offerId: string): void {
    console.log('Triggering offer to nearby users:', offerId);
    this.triggerOffersInfoMsg = 'Offer successfully sent to nearby users!';
    
    // Show and then hide the notification
    setTimeout(() => {
      this.triggerOffersInfoMsg = '';
    }, 3000);
  }

  offerApprove(offerId: string): void {
    console.log('Approving offer:', offerId);
    const offer = this.offers.find(o => o._id === offerId);
    if (offer) {
      offer.is_approved = true;
    }
  }

  offerDisapprove(offerId: string): void {
    console.log('Disapproving offer:', offerId);
    const offer = this.offers.find(o => o._id === offerId);
    if (offer) {
      offer.is_approved = false;
    }
  }

  generateCouponCode(): void {
    const genericCode = document.getElementById('genericCode') as HTMLInputElement;
    const numberOfCouponCode = document.getElementById('numberOfCouponCode') as HTMLInputElement;
    const prefixCode = document.getElementById('prefixCode') as HTMLInputElement;
    const numberOfCoupons = document.getElementById('numberOfCoupons') as HTMLInputElement;
    const lengthOfCouponCode = document.getElementById('lengthOfCouponCode') as HTMLInputElement;
    
    let data: any = {};
    
    if (this.couponTypes.is_generic) {
      data = {
        type: 'generic',
        code: genericCode?.value,
        count: numberOfCouponCode?.value || '5000'
      };
    } else {
      data = {
        type: 'unique',
        prefix: prefixCode?.value,
        count: numberOfCoupons?.value || '5000',
        length: lengthOfCouponCode?.value || '8'
      };
    }
    
    console.log('Generating coupon codes:', data);
    alert('Coupon codes generated successfully!');
    
    // Would typically close modal
    (document.getElementById('generateCouponCode') as any).modal('hide');
  }

  uploadCouponFile(): void {
    console.log('Uploading coupon file');
    // Would typically upload file
    alert('File uploaded successfully!');
  }

  checkInputFile(): void {
    console.log('Checking input file');
    // Enable upload button
    (document.getElementById('btnCouponUploadFile') as HTMLButtonElement).disabled = false;
  }

  nextPage(): void {
    this.pagerBusy = true;
    
    // Simulate loading more data
    setTimeout(() => {
      // Add more dummy offers
      const newOffers: Offer[] = [
        {
          _id: '5',
          headline: 'Spring Collection',
          sub_title: 'New Arrivals',
          public_img_url: 'assets/offers/spring.jpg',
          is_default: false,
          is_approved: true,
          cta: {
            action_type: 'redirect'
          }
        },
        {
          _id: '6',
          headline: 'Flash Sale',
          sub_title: '24 Hours Only',
          public_img_url: 'assets/offers/flash-sale.jpg',
          is_default: false,
          is_approved: true,
          cta: {
            action_type: 'redirect'
          }
        }
      ];
      
      this.offers = [...this.offers, ...newOffers];
      this.pagerBusy = false;
      
      // Set flag when no more data is available
      if (this.offers.length >= 10) {
        this.noMoreData = true;
      }
    }, 1000);
  }
}
